import { Pipe, PipeTransform } from '@angular/core';
import * as R from 'ramda';

import { I18nService } from '../../@core/utils';

@Pipe({
    name: 'ngxCurrency',
    standalone: true
})
export class CurrencyPipe implements PipeTransform {

  transform(value: number, currency: string, decPlaces?: number): string {
    if (!R.isNil(value)) {
      return I18nService.formatCurrencyValue(value, currency, decPlaces);
    }
  }
}
